import { Injectable } from '@angular/core';
import { deepCopy } from '@delon/util';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  /** 数据源 */
  private source: Array<any>;

  constructor() { }

  /**
   * 设置消息类型配置文件
   * */
  setData(data: any): void {
    this.source = data;
  }

  /**
   * 获取消息类型配置文件
   * */
 getData(): void {
  return deepCopy(this.source);
 }

}
